const Marquee = ({ items, className = "", outline = true, testId = "editorial-marquee" }) => {
  const row = (key) => (
    <div key={key} className="flex shrink-0 items-center">
      {items.map((item, i) => (
        <span key={i} className="flex items-center">
          <span
            className={`whitespace-nowrap px-8 font-display text-5xl sm:text-7xl italic ${
              outline ? "text-outline" : "text-forest"
            }`}
          >
            {item}
          </span>
          <span className="h-2 w-2 rounded-full bg-ochre" />
        </span>
      ))}
    </div>
  );
  return (
    <div
      data-testid={testId}
      className={`relative overflow-hidden py-10 select-none ${className}`}
      aria-hidden="true"
    >
      <div className="animate-marquee flex w-max">
        {row("a")}
        {row("b")}
      </div>
    </div>
  );
};

export default Marquee;
